import * as React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { sessionStore } from "common/stores";
import { authService } from "common/services";

export default function Auth0Bridge(): JSX.Element {
	const {
		isLoading,
		isAuthenticated,
		loginWithRedirect,
		getAccessTokenSilently,
		logout,
		user,
	} = useAuth0();

	React.useEffect(() => {
		authService.setLogout(() =>
			logout({ logoutParams: { returnTo: window.location.origin } })
		);
	}, [logout]);

	React.useEffect(() => {
		authService.setAccessTokenProvider(() => getAccessTokenSilently());
	}, [getAccessTokenSilently]);

	React.useEffect(() => {
		if (isLoading) {
			return;
		}

		if (!isAuthenticated) {
			loginWithRedirect();
			return;
		}

		let cancelled = false;

		(async () => {
			try {
				const token = await getAccessTokenSilently();
				await sessionStore.onAuthenticated(token, user);
			} catch (err) {
				if (!cancelled) {
					// Auth0 can still report isAuthenticated from a stale cache while
					// the refresh token is dead — force a fresh login instead of NoAccess.
					loginWithRedirect();
				}
			}
		})();

		return () => {
			cancelled = true;
		};
	}, [isLoading, isAuthenticated]);

	return null;
}
